import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';

const Footer = ({ staggerItem }) => {
  const { github, linkedin, email } = portfolioData.social;

  const socialLinks = [
    { name: 'GitHub', icon: 'mdi:github', href: github, color: 'hover:text-gray-400' },
    { name: 'LinkedIn', icon: 'mdi:linkedin', href: linkedin, color: 'hover:text-blue-500' },
    { name: 'Email', icon: 'mdi:email', href: `mailto:${email}`, color: 'hover:text-red-500' },
  ];

  return (
    <footer id="footer" className="py-20 bg-white dark:bg-gray-900 text-gray-900 dark:text-white border-t border-gray-200 dark:border-gray-800 transition-colors duration-300">
      <div className="container mx-auto px-6">
        <motion.div 
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerItem}
          className="text-center flex flex-col items-center"
        >
          <h3 className="text-3xl font-bold mb-6">
            <span className="underline-3d">Let's connect</span>
          </h3>
          
          <motion.a 
            href={`mailto:${email}`} 
            className="text-lg md:text-xl font-medium text-gray-600 dark:text-gray-400 hover:text-blue-600 transition-all duration-300 mb-10 flex items-center justify-center gap-3 bg-gray-50 dark:bg-gray-800/50 px-6 sm:px-8 py-3 sm:py-4 rounded-full border border-gray-200 dark:border-gray-700 hover:border-blue-500 shadow-lg hover:shadow-blue-500/20 group backdrop-blur-sm"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <div className="bg-gray-100 dark:bg-gray-700 p-2 rounded-full group-hover:bg-blue-600 transition-colors duration-300">
              <Icon icon="mdi:email-fast-outline" className="text-xl md:text-2xl text-blue-400 dark:text-blue-600 group-hover:text-white transition-colors" />
            </div>
            {email}
          </motion.a>

          <div className="flex justify-center space-x-8 mb-8">
            {socialLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                target="_blank" 
                rel="noopener noreferrer"
                className={`relative text-gray-500 dark:text-gray-400 ${link.color} transition-all duration-300 hover:scale-110 group`}
              >
                <Icon icon={link.icon} className="text-4xl" />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-2 py-1 bg-blue-600 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
                  {link.name}
                </span>
              </a>
            ))}
            <a 
              href={portfolioData.social.cv} 
              target="_blank" 
              rel="noopener noreferrer"
              className="relative text-gray-500 dark:text-gray-400 hover:text-blue-400 transition-all duration-300 hover:scale-110 group"
            >
              <Icon icon="mdi:file-document-outline" className="text-4xl" />
              <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-2 py-1 bg-blue-600 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
                Stiahnuť CV
              </span>
            </a>
          </div>
          
          <div className="text-gray-400 dark:text-gray-500 text-sm font-mono mt-8 border-t border-gray-200 dark:border-gray-800 pt-8 w-full max-w-lg">
            © {new Date().getFullYear()} Mario Panenko | Built with React & Framer Motion
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
